<template>
    <div class="cont_box">
        <div class="backg_box">
            <el-carousel @change="changFn" trigger="click" arrow="never" :height="700 + 'px'">
                <el-carousel-item v-for="(item,index) in banneList" :key="index">
                    <img oncontextmenu="return false;" ondragstart="return false;" :src="item.thumbUrl" alt="" class="b_img">
                </el-carousel-item>
            </el-carousel>
            <div class="insect_dec">
                <div class="insect_p">
                    中文名：{{banneList[bann_index].cnName}}
                </div>
                <!--				<div class="insect_p">-->
                <!--					俗名：{{banneList[bann_index].commonName}}-->
                <!--				</div>-->
                <div class="insect_p" v-if="banneList[bann_index].type == 'PEST'&&banneList[bann_index].latinName">
                    <!--                    拉丁名：<span :class="{'ld_font': banneList[bann_index].type == 'PEST'}">{{banneList[bann_index].latinName}}</span>-->
                    拉丁名：<span>{{banneList[bann_index].latinName}}</span>
                </div>
                <div class="insect_p" v-if="!!banneList[bann_index].remark">
                    {{banneList[bann_index].remark}}
                </div>
            </div>
        </div>
        <div class="insect_home">
            <div class="insect_ent">
                <div class="insect_ent_item" @click="nh_btn(item)" v-for="(item,index) in fl_list" :key="index">
                    <div class="insect_ent_item_icon">
                        <img :src="item.thumbnail" alt="" class="icon">
						<div class="insect_ent_item_title">
						    {{item.name}}
						</div>
                    </div>
					<div class="insect_ent_item_cont">
					    {{item.remark}}{{item.remark}}
					</div>
                </div>
            </div>
            <div class="insect_story">
                <div class="insect_story_box">
                    <div class="insect_story_title">
                        <div class="insect_story_name">
                            近似种类
                        </div>
                        <div class="insect_story_more" @click="ckgd_btn">
                            <span>查看更多</span>
                            <img src="../assets/image/icon_tpgs_enter@2x.png" alt="" class="icon">
                        </div>
                    </div>
                    <div class="insect_story_cont">
                        <div class="insect_story_item" @click="insect_btn(item)" v-for="(item,index) in gs_list.records"
                             :key="index">
                            <img oncontextmenu="return false;" ondragstart="return false;" :src="item.coverUrl" alt="" class="bag">
                            <div class="insect_story_item_rig">
                                <div class="insect_story_item_title">
                                    {{item.title}}
                                </div>
                                <div class="insect_story_item_p">
                                    {{item.content}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="notice_hei" @click="g_btn" v-if="not_flag">
            <div class="notice_box" @click.stop="">
                <div class="notice_left" @click="g_btn">
                    <img src="../assets/image/icon_bqgg_tc_close@2x.png" alt="" class="icon">
                    <span>立即关闭</span>
                </div>
                <div class="notice_right">
                    <span>剩余时间：{{this.jj_s}}s</span>
                </div>
                <div class="notice_title">
                    版权公告
                </div>
                <div class="notice_content" v-html="gg_data.noticeContent">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import headers from '@/components/header';
    import foot from '@/components/foot';

    export default {
        data() {
            return {
                bann_index: 0,
                not_flag: false,
                banneList: [{
                    cnName: "",
                    commonName: "",
                    latinName: "",
                    thumbUrl: "",
                    type: "PEST",
                }], // 轮播集合
                jj_s: 20, // 计时关闭
                setInv: '', // 函数
                fl_list: [], // 分类列表
                gg_data: '', // 公告信息
                gs_list: {
                    records: []
                }, // 故事列表
            }
        },
        computed: {
            noticeFlag() {
                return this.$store.state.noticeFlag
            },
            getBannerHeight() {
                // 图片宽高3：1
                return document.body.clientWidth / 3;
            }
        },

        mounted() {
            this.init()
        },
        methods: {
            insect_btn(item) {
				this.$store.commit('SET_TAB', 'tpgs')
                this.$router.push({
                    name: 'story_dec',
                    query: {
                        id: item.id
                    }
                })
            },
            ckgd_btn() {
				this.$store.commit('SET_TAB', 'tpgs')
                this.$router.push({
                    path: 'story_index'
                })
            },
            nh_btn(item) {
                this.$router.push({
                    name: 'galleryIndex'
                })
				this.$store.commit('SET_TAB', 'tk')
				this.$store.commit('SET_GALY', item.code)
            },
            g_btn() {
                this.not_flag = false
                clearInterval(this.setInv)
                this.$store.commit('SET_NOT', false)
            },
            init() {
                this.$http.get(`/front/banner/list`).then(res => {
                    this.banneList = res.data
                });
                this.$http.get(`/front/gallery/category/home`).then(res => {
                    this.fl_list = res.data
										console.log(res.data)
                });
                this.$http.post(`/front/picture/store/list`, {
                    page: 1,
                    size: 3,
                }).then(res => {
                    let data = res.data
                    for (let item of data.records) {
                        item.content = item.content.replace(/<[^<>]+>/g, '').replace(/&nbsp;/ig, '').trim()
                    }
                    console.log(data)
                    this.gs_list = data
                });
                if (this.noticeFlag) {
                    this.$http.get(`/front/notice/copyright`).then(res => {
                        let data = res.data
                        if (data.noticeContent) {
                            this.setInv = setInterval(res => {
                                this.jj_s--
                                if (this.jj_s == 0) {
                                    this.not_flag = false
                                    clearInterval(this.setInv)
                                    this.$store.commit('SET_NOT', false)
                                }
                            }, 1000)
                            this.not_flag = true
                            this.gg_data = data
                        } else {
                            this.$store.commit('SET_NOT', false)
                        }
                    });
                }

            },
            changFn(e) {
                this.bann_index = e
            }
        }
    }
</script>

<style lang="less" scoped>
	.cont_box{
		background: #EDF4FE;
		
	}
    .notice_hei {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .2);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 100;

        .notice_box {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            //width: 880px;
						width: 1200px;
            height: 400px;
            background: url(../assets/image/pic_hptc_bg@2x.png) no-repeat;
            background-size: 100% 100%;
            background-position: center;

            .notice_left {
                position: absolute;
                top: 35px;
                left: 35px;
                display: flex;
                align-items: center;
                cursor: pointer;

                .icon {
                    width: 23px;
                    height: 23px;
                    margin-right: 8px;
                }

                span {
                    font-size: 13px;
                    color: #4A4A4A;
                }
            }

            .notice_right {
                position: absolute;
                top: 40px;
                right: 35px;

                span {
                    font-size: 14px;
                    color: #4A4A4A;
                }
            }

            .notice_title {
                height: 89px;
                line-height: 89px;
                font-size: 23px;
                color: #22AB67;
                font-weight: bold;
                text-align: center;
            }

            .notice_content {
                width: 678px;
                height: 251px;
                overflow-y: auto;
                margin: 0 auto;
                line-height: 1.3;
            }
        }
    }

    .insect_home {
        background: #EDF4FE;
        overflow: hidden;

        .insect_story {
            margin-bottom: 50px;

            .insect_story_box {
                //width: 870px;
								width: 1200px;
                margin: 0 auto;
                padding: 0 36px 23px;
                box-sizing: border-box;
                background-color: #fff;

                .insect_story_title {
                    height: 65px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .insect_story_name {
                        font-size: 18px;
                        font-weight: bold;
                    }

                    .insect_story_more {
                        display: flex;
                        align-items: center;
                        cursor: pointer;

                        span {
                            font-size: 12px;
                            margin-right: 13px;
                            line-height: 1;
                        }

                        .icon {
                            width: 18px;
                            height: 18px;
                        }
                    }
                }

                .insect_story_cont {
					display: flex;
                    .insect_story_item {
                        cursor: pointer;
						width: 240px;

                        .bag {
                            width: 240px;
                            height: 240px;
                            object-fit: cover;
                            margin-bottom: 23px;
                        }

                            .insect_story_item_title {
                                font-weight: bold;
								font-size: 16px;
								margin-bottom: 18px;
                            }

                            .insect_story_item_p {
                                font-size: 13px;
                                color: #4A4A4A;
                                line-height: 2;
                                width: 100%;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                /*! autoprefixer: off */
                                display: -webkit-box;
                                -webkit-line-clamp: 5;
                                -webkit-box-orient: vertical;
                            }
                    }
                }
            }
        }

        .insect_ent {
            margin: 0 auto;
            padding: 41px 0 30px;
            //width: 870px;
						width: 1200px;
            display: flex;
			position: relative;
			z-index: 1;
            justify-content: space-between;

            .insect_ent_item {
                background: #fff;
                //width: 413px;
								width: 550px;
                box-sizing: border-box;
                cursor: pointer;
				.insect_ent_item_icon{
					//height: 240px;
					height: 300px;
					position: relative;
					.icon{
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
					}
					.insect_ent_item_title{
						position: relative;
						z-index: 1;
						background: rgba(0,0,0,.5);
						text-align: center;
						//line-height: 240px;
						line-height: 300px;
						font-size: 38px;
						color: #fff;
						font-weight: bold;
					}
				}
				.insect_ent_item_cont{
					padding: 13px 32px;
					height: 84px;
					box-sizing: border-box;
					overflow: hidden;
					line-height: 2;
					text-overflow: ellipsis;
					/*! autoprefixer: off */
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
				}
            }
        }
    }

    .b_img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .backg_box {
        position: relative;
		//width: 870px;
		width: 1200px;
		margin: 0 auto;
        .insect_dec {
            position: absolute;
            bottom: 35px;
            left: 35px;
            background: rgba(0, 0, 0, .2);
            z-index: 100;
            width: 435px;
            box-sizing: border-box;
            padding: 25px 30px;

            .insect_p {
                color: #fff;
                font-size: 18px;
                margin-bottom: 24px;
				line-height: normal;

                &:last-child {
                    margin-bottom: 0;
                }
            }

        }
    }

    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 150px;
        margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
    }

    /deep/ .el-carousel__button {
        width: 10px;
        height: 10px;
        background-color: rgba(255, 255, 255, .4);
        border-radius: 50%;
    }

    /deep/ .is-active {
        .el-carousel__button {
            width: 30px;
            height: 10px;
            background: #FFFFFF;
            border-radius: 5px;
        }
    }
</style>
